import axiosInstance from "../utils/axios";

export const dashboardService = {
  fetchData: async () => {
    const response = await axiosInstance.get(
      "/vocational-institution/dashboard"
    );
    return response.data;
  },
  fetchTrainingCatalogData: async () => {
    const response = await axiosInstance.get(
      "/training-catalog/dashboard"
    );
    return response.data;
  }
};
